import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { AdministrarPatEdit, TipoTarjeta, UpdatePatDTO } from "../models/administrarPat";
import { id } from "date-fns/locale";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";


const editarPat = async (data: UpdatePatDTO) => {
    console.log('data', data)
    const response: AxiosResponse = await axiosInstance.put(
        `siscred-api-recaudacion/v1/pat/actualizar/${data.MutuoId}`,
        data
    );
    return response;
};

const getValidarPat = async (idMutuo: number) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-recaudacion/v1/pat/validar`, {
        params: { mutuoId: idMutuo },
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });
    return response;

};

const eliminarPat = async (mutuoId: number) => {
    const response: AxiosResponse<void> = await axiosInstance.delete(
        `siscred-api-recaudacion/v1/pat/eliminar/${mutuoId}`
    );
    return response.status === 204;
};

const getCuota = async (mutuoId: number) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-recaudacion/v1/pat/get-cuota`, {
        params: { mutuoId: mutuoId }
    })
    return response;

};

const getTipoTarjeta = async () => {
    const response: AxiosResponse<ListResponseDto<TipoTarjeta>> = await axiosInstance.get(`siscred-api-transversal/v1/tarjetas/tipos-tarjeta`);

    return response;
}

export {
    editarPat,
    getValidarPat,
    eliminarPat,
    getCuota,
    getTipoTarjeta
}